import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import tableByApr from '../tableByApr/tableByApr.vue'
import logApr from '../logApr/logApr.vue'
import { toast, loading } from '@/shared/utils/UIHelper'
import tableEpi from '../tableEpi/tableEpi.vue'
import tableFerrementas from '../toolsTable/toolsTable.vue'
import tableRiscoEspecial from '../specialRisks/specialRisks.vue'
import tableCourseNR from '../courseNR/courseNR.vue'
import aprTemplate from '@/shared/http/repositories/business/aprTemplate'
import detalhesTemplate from '../detalhesTemplate/detalhesTemplate.vue'
import returnGridTemplate from '../returnGridTemplate/returnGridTemplate.vue'
import newTemplate from '../newTemplate/newTemplate.vue'

export default {
  name: 'tabsApr',
  props: ['aprId', 'revisao', 'carregaAbas', 'codigo', 'statusTemplate'],
  components: {HeadDetailsGama, tableByApr, logApr, tableEpi, detalhesTemplate, tableFerrementas, tableRiscoEspecial, tableCourseNR, returnGridTemplate, newTemplate},
  mixins: [ActionsForm],
  data () {
    return {
      tabs: 0,
      tabIndex: 0,
      revisaoEdicao: null,
      liberaClonar: 0,
      dataEpi: [],
      dataFerramentas: [],
      dataRiscoEspecial: [],
      dataRiscoEspecialExclusao: [],
      dataEpiExclusao: [],
      dataFerramentasExclusao: [],
      dataCursosNR: [],
      dataCursosNRExclusao: [],
      dataRiscoFonteConsequenciaMedida: [],
      dataEtapaServicoRiscoFonteConsequenciaMedida: [],
      edicaoDataRiscoFonteConsequenciaMedida: [],
      dataRisco: [],
      dataRiscoExclusao: [],
      dataCausaExclusao: [],
      aprTemplateAgAprovacao: false,
      aprTemplateReprovado: false,
      matrizRisco: [],
      templateClonado: {},
      clonagemTabela: false
    }
  },
  watch: {
    carregaAbas (newRevisao) {
      this.$refs.refEpiByApr.onLoad(newRevisao)
      this.$refs.refTablaByApr.onLoad(newRevisao)

      this.$refs.refFerramentasByApr.onLoad(newRevisao)
      this.$refs.refRiscoEspecialByApr.onLoad(newRevisao)
      this.$refs.refCursosNrByApr.onLoad(newRevisao)
      this.$refs.refAprLog.onLoad()
    }
  },
  methods: {
    voltar () {
      if (this.dataRiscoFonteConsequenciaMedida.length > 0 ||
         (this.dataEpi.length > 0 ? this.dataEpi[0].epi.length > 0 : false) ||
         (this.dataRiscoEspecial.length > 0 ? this.dataRiscoEspecial[0].riscosEspeciais.length > 0 : false) ||
         (this.dataFerramentas.length > 0 ? this.dataFerramentas[0].dataFerramentas.length > 0 : false) ||
         (this.dataCursosNR.length > 0 ? this.dataCursosNR[0].CursosNR.length > 0 : false) ||
         (this.matrizRisco.length > 0) ||
         this.dataEpiExclusao.length > 0 ||
         this.dataCausaExclusao.length > 0 ||
         this.dataRiscoExclusao.length > 0 ||
         this.dataCursosNRExclusao.length > 0 ||
         this.dataFerramentasExclusao.length > 0 ||
         this.edicaoDataRiscoFonteConsequenciaMedida.length > 0 ||
         this.dataRiscoEspecialExclusao.length > 0) {
        this.$refs['confimacao-retornar'].show()
      } else {
        document.location.reload()
      }
    },
    popUptAddClonagem () {
      this.liberaClonar = this.statusTemplate === 0 ? 1 : 0
      this.clonagemTabela = false
      this.$refs['add-novo-template'].show()
    },
    avancaClonagem () {
      this.liberaClonar = 0
    },
    cancelarAddTemplate () {
      this.$refs['add-novo-template'].hide()
    },
    confirmacaoVoltar () {
      this.$refs['confimacao-retornar'].hide()
      document.location.reload()
    },
    cancelarVoltar () {
      this.$refs['confimacao-retornar'].hide()
    },
    novosRiscosTemplateVazio () {
      this.abrirPopUpRisco()
    },
    abrirPopUpRisco () {
      this.$refs.refTablaByApr.popUptAddRisco()
    },
    abrirPopUpEtapaServico () {
      this.$refs.refTablaByApr.popUptAddServiceStage()
    },
    abrirPopUpEpi () {
      this.$refs.refEpiByApr.popUptAddEpi()
    },
    abrirPopUpFerramentas () {
      this.$refs.refFerramentasByApr.popUptAddFerramentas()
    },
    abrirPopUpRiscoEspecial () {
      this.$refs.refRiscoEspecialByApr.popUptAddRiscoEspecial()
    },
    abrirPopUpCursosNR () {
      this.$refs.refCursosNrByApr.popUptAddcursosNR()
    },
    salvarRiscoFonteConsequenciaMedida (value) {
      if (this.dataRiscoFonteConsequenciaMedida !== null || this.dataRiscoFonteConsequenciaMedida !== undefined) {
        this.dataRiscoFonteConsequenciaMedida.push(value)
      } else {
        this.dataRiscoFonteConsequenciaMedida = value
      }
    },
    removerListaDeAlteracoesCausaByRiscoId (value) {
      for (let i = 0; i < this.dataRiscoFonteConsequenciaMedida.length; i++) {
        if (this.dataRiscoFonteConsequenciaMedida[i].riscoId === value.riscoId) {
          if (this.dataRiscoFonteConsequenciaMedida[i].itens.naturezaRisco === value.causaid) {
            // Remover o item 'itens'
            delete this.dataRiscoFonteConsequenciaMedida[i].itens

            // Se 'itens' está vazio ou foi removido, opcionalmente remova o objeto principal
            if (!this.dataRiscoFonteConsequenciaMedida[i].hasOwnProperty('itens')) {
              this.dataRiscoFonteConsequenciaMedida.splice(i, 1)
              // Decrementa i para não pular o próximo item
              i--
            }
            this.removerListaDeAlteracoesAvalicaoByCausaIdByRiscoId(value)
          }
        }
      }
    },
    removerListaDeAlteracoesAvalicaoByCausaIdByRiscoId (value) {
      for (let i = 0; i < this.matrizRisco.length; i++) {
        if (this.matrizRisco[i].riscoId === value.riscoId) {
          if (this.matrizRisco[i].causaId === value.causaid) {
            // Remover o item 'itens'
            delete this.matrizRisco[i].itens

            // Se 'itens' está vazio ou foi removido, opcionalmente remova o objeto principal
            if (!this.matrizRisco[i].hasOwnProperty('itens')) {
              this.matrizRisco.splice(i, 1)
              // Decrementa i para não pular o próximo item
              i--
            }
          }
        }
      }
    },
    removerListaDeAlteracoesByRiscoId (value) {
      for (let i = 0; i < this.dataRiscoFonteConsequenciaMedida.length; i++) {
        if (this.dataRiscoFonteConsequenciaMedida[i].etapaServicoId === value.etapaServico) {
          if (this.dataRiscoFonteConsequenciaMedida[i].riscoId === value.riscoId) {
            // Remover o item 'itens'
            delete this.dataRiscoFonteConsequenciaMedida[i].itens
            // Se 'itens' está vazio ou foi removido, opcionalmente remova o objeto principal
            if (!this.dataRiscoFonteConsequenciaMedida[i].hasOwnProperty('itens')) {
              this.dataRiscoFonteConsequenciaMedida.splice(i, 1)
              // Decrementa i para não pular o próximo item
              i--
            }
            this.removerListaDeAlteracoesAvalicaoByRiscoId(value)
          }
        }
      }
    },
    removerListaDeAlteracoesAvalicaoByRiscoId (value) {
      for (let i = 0; i < this.matrizRisco.length; i++) {
        if (this.matrizRisco[i].etapaServico === value.etapaServico) {
          if (this.matrizRisco[i].riscoId === value.riscoId) {
            // Remover o item 'itens'
            delete this.matrizRisco[i].itens
            // Se 'itens' está vazio ou foi removido, opcionalmente remova o objeto principal
            if (!this.matrizRisco[i].hasOwnProperty('itens')) {
              this.matrizRisco.splice(i, 1)
              // Decrementa i para não pular o próximo item
              i--
            }
          }
        }
      }
    },

    editarRiscoFonteConsequenciaMedidaItens (value) {
      if (this.edicaoDataRiscoFonteConsequenciaMedida !== null || this.edicaoDataRiscoFonteConsequenciaMedida !== undefined) {
        this.edicaoDataRiscoFonteConsequenciaMedida.push(value)
      } else {
        this.edicaoDataRiscoFonteConsequenciaMedida = value
      }
    },
    salvarEpi (value) {
      if (this.dataEpi !== null && this.dataEpi !== undefined && this.dataEpi.length > 0) {
        for (let i = 0; i < value.epi.length; i++) {
          this.dataEpi[0].epi.push(value.epi[i])
        }
      } else {
        this.dataEpi[0] = value
      }
    },
    removerListaDeAlteracoesEPI (value) {
      if (this.dataEpi[0].epi.length === 1) {
        this.dataEpi = []
      } else if (this.dataEpi[0].epi.length > 0) {
        this.dataEpi[0].epi = this.dataEpi[0].epi.filter(epiId => epiId !== value.epiId)
      }
    },
    excluirEpi (value) {
      if (this.dataEpiExclusao !== null || this.dataEpiExclusao !== undefined) {
        this.dataEpiExclusao.push(value)
      } else {
        this.dataEpiExclusao = value
      }
    },
    removerListaDeAlteracoesByEtapaServico (value) {
      if (this.dataEtapaServicoRiscoFonteConsequenciaMedida !== null || this.dataEtapaServicoRiscoFonteConsequenciaMedida !== undefined) {
        this.dataEtapaServicoRiscoFonteConsequenciaMedida.push(value)
      } else {
        this.dataEtapaServicoRiscoFonteConsequenciaMedida = value
      }
    },
    removerListaDeInclusaoByEtapaServico (value) {
      for (let i = 0; i < this.dataRiscoFonteConsequenciaMedida.length; i++) {
        if (this.dataRiscoFonteConsequenciaMedida[i].etapaServicoId === value.EtapaServico) {
          // Remover o item 'itens'
          if (this.dataRiscoFonteConsequenciaMedida.length === 1) {
            this.dataRiscoFonteConsequenciaMedida.splice(i)
          } else {
            this.dataRiscoFonteConsequenciaMedida.splice(i, 1)
            i--
          }

          this.removerListaDeAlteracoesAvalicaoByEtapaServicoId(value)
        }
      }
    },
    removerListaDeAlteracoesAvalicaoByEtapaServicoId (value) {
      for (let i = 0; i < this.matrizRisco.length; i++) {
        if (this.matrizRisco[i].etapaServico === value.EtapaServico) {
          // Remover o item 'itens'

          if (this.matrizRisco.length === 1) {
            this.matrizRisco.splice(i)
          } else {
            this.matrizRisco.splice(i, 1)
          }
          i--
        }
      }
    },
    addListaDeAlteracoesByEtapaServico (value) {
      if (this.dataEtapaServicoRiscoFonteConsequenciaMedida !== null || this.dataEtapaServicoRiscoFonteConsequenciaMedida !== undefined) {
        this.dataEtapaServicoRiscoFonteConsequenciaMedida.push(value)
      } else {
        this.dataEtapaServicoRiscoFonteConsequenciaMedida = value
      }
    },
    salvarFerramentas (value) {
      if (this.dataFerramentas !== null && this.dataFerramentas !== undefined && this.dataFerramentas.length > 0) {
        for (let i = 0; i < value.ferramentas.length; i++) {
          this.dataFerramentas[0].ferramentas.push(value.ferramentas[i])
        }
      } else {
        this.dataFerramentas[0] = value
      }
    },
    removerListaDeAlteracoesFerramentas (value) {
      if (this.dataFerramentas[0].ferramentas.length === 1) {
        this.dataFerramentas = []
      } else if (this.dataFerramentas[0].ferramentas.length > 0) {
        this.dataFerramentas[0].ferramentas = this.dataFerramentas[0].ferramentas.filter(ferramentasId => ferramentasId !== value.ferramentaId)
      }
    },
    excluirRiscoEspecial (value) {
      if (this.dataRiscoEspecialExclusao !== null || this.dataRiscoEspecialExclusao !== undefined) {
        this.dataRiscoEspecialExclusao.push(value)
      } else {
        this.dataRiscoEspecialExclusao = value
      }
    },
    salvarRiscoEspecial (value) {
      if (this.dataRiscoEspecial !== null && this.dataRiscoEspecial !== undefined && this.dataRiscoEspecial.length > 0) {
        for (let i = 0; i < value.riscosEspeciais.length; i++) {
          this.dataRiscoEspecial[0].riscosEspeciais.push(value.riscosEspeciais[i])
        }
      } else {
        this.dataRiscoEspecial[0] = value
      }
    },
    removerListaDeAlteracoesRiscosEspeciais (value) {
      if (this.dataRiscoEspecial[0].riscosEspeciais.length === 1) {
        this.dataRiscoEspecial = []
      } else if (this.dataRiscoEspecial[0].riscosEspeciais.length > 0) {
        this.dataRiscoEspecial[0].riscosEspeciais = this.dataRiscoEspecial[0].riscosEspeciais.filter(riscosEspeciaisId => riscosEspeciaisId !== value.riscosEspeciaisId)
      }
    },
    excluirFerramentas (value) {
      if (this.dataFerramentasExclusao !== null || this.dataFerramentasExclusao !== undefined) {
        this.dataFerramentasExclusao.push(value)
      } else {
        this.dataFerramentasExclusao = value
      }
    },
    causaExcluir (value) {
      if (this.dataCausaExclusao !== null || this.dataCausaExclusao !== undefined) {
        this.dataCausaExclusao.push(value)
      } else {
        this.dataCausaExclusao = value
      }
    },
    cancelaExclusao (value) {
      if (this.dataCausaExclusao !== null || this.dataCausaExclusao !== undefined) {
        this.dataCausaExclusao.pop(value)
        this.dataRiscoExclusao.pop(value)
        this.dataEtapaServicoRiscoFonteConsequenciaMedida.pop(value)
      } else {
        this.dataCausaExclusao = value
      }
    },
    riscoExcluir (value) {
      if (this.dataRiscoExclusao !== null || this.dataRiscoExclusao !== undefined) {
        this.dataRiscoExclusao.push(value)
      } else {
        this.dataRiscoExclusao = value
      }
    },
    cancelarriscoExcluir (value) {
      if (this.dataRiscoExclusao !== null || this.dataRiscoExclusao !== undefined) {
        this.dataRiscoExclusao.pop(value)
      } else {
        this.dataRiscoExclusao = value
      }
    },
    excluirCursosNR (value) {
      if (this.dataCursosNRExclusao !== null || this.dataCursosNRExclusao !== undefined) {
        this.dataCursosNRExclusao.push(value)
      } else {
        this.dataCursosNRExclusao = value
      }
    },
    salvarCursosNR (value) {
      if (this.dataCursosNR !== null && this.dataCursosNR !== undefined && this.dataCursosNR.length > 0) {
        for (let i = 0; i < value.CursosNR.length; i++) {
          this.dataCursosNR[0].CursosNR.push(value.CursosNR[i])
        }
      } else {
        this.dataCursosNR[0] = value
      }
    },
    removerListaDeAlteracoesCursosNR (value) {
      if (this.dataCursosNR[0].CursosNR.length === 1) {
        this.dataCursosNR = []
      } else if (this.dataCursosNR[0].CursosNR.length > 0) {
        this.dataCursosNR[0].CursosNR = this.dataCursosNR[0].CursosNR.filter(cursosNR => cursosNR !== value.cursosNRId)
      }
    },
    avaliacaoMatrizRisco (value) {
      if (this.matrizRisco !== null || this.matrizRisco.length > 0) {
        for (let i = 0; i < this.matrizRisco.length; i++) {
          if (this.matrizRisco[i].riscoId === value.riscoId && this.matrizRisco[i].causaId === value.causaId) {
            this.matrizRisco[i].itens.severidade = value.itens.severidade
            this.matrizRisco[i].itens.probabilidade = value.itens.probabilidade
            this.matrizRisco[i].itens.classificacao = value.itens.classificacao
            return this.matrizRisco
          }
        }
        this.matrizRisco.push(value)
      } else {
        this.matrizRisco = value
      }
    },
    TemplateAgAprovacao (value) {
      this.aprTemplateAgAprovacao = value
    },
    TemplateReprovado (value) {
      this.aprTemplateReprovado = value
    },
    salvar () {
      loading.push()
      this.riscoAddAvaliacao(this.matrizRisco)
      this.edicaoRiscoAddAvaliacao(this.matrizRisco)

      let dados = {
        APRid: this.aprId,
        riscos: this.dataRiscoFonteConsequenciaMedida,
        edicaoRiscos: this.edicaoDataRiscoFonteConsequenciaMedida,
        epi: this.dataEpi,
        epiExclusao: this.dataEpiExclusao,
        CausasExclusao: this.dataCausaExclusao,
        RiscoExclusaoId: this.dataRiscoExclusao,
        ferramentas: this.dataFerramentas,
        ferramentasExclusao: this.dataFerramentasExclusao,
        riscosEspeciais: this.dataRiscoEspecial,
        riscosEspeciaisExclusao: this.dataRiscoEspecialExclusao,
        edicaoAvaliacaoRisco: this.matrizRisco,
        cursosNR: this.dataCursosNR,
        cursosNRExclusao: this.dataCursosNRExclusao,
        exclusaoEtapaServico: this.dataEtapaServicoRiscoFonteConsequenciaMedida
      }
      if (dados.riscos.length > 0 ||
          (dados.epi.length > 0 ? dados.epi[0].epi.length > 0 : false) ||
          (dados.riscosEspeciais.length > 0 ? dados.riscosEspeciais[0].riscosEspeciais.length > 0 : false) ||
          (dados.ferramentas.length > 0 ? dados.ferramentas[0].ferramentas.length > 0 : false) ||
          (dados.cursosNR.length > 0 ? dados.cursosNR[0].CursosNR.length > 0 : false) ||
          (dados.riscosExclusao !== undefined && dados.riscosExclusao !== null) ||
          (dados.exclusaoEtapaServico !== undefined && dados.exclusaoEtapaServico !== null) ||
          (dados.edicaoAvaliacaoRisco.length > 0) ||
           dados.epiExclusao.length > 0 ||
           dados.CausasExclusao.length > 0 ||
           dados.RiscoExclusaoId.length > 0 ||
           dados.cursosNRExclusao.length > 0 ||
           dados.ferramentasExclusao.length > 0 ||
           dados.edicaoRiscos.length > 0 ||
           dados.riscosEspeciaisExclusao.length > 0) {
        let validacaoAvaliacao = this.verificaSeTemAvaliacao(dados.riscos)

        if (validacaoAvaliacao) {
          loading.pop()
          return toast.warning(validacaoAvaliacao)
        }
        aprTemplate.EdicaoAddAPRTemplate(dados)
          .then((Response) => {
            loading.pop()
            this.revisaoEdicao = Response.data.result
            this.$emit('recarregarTemplateEdicao', this.revisaoEdicao)
            this.$refs.refEpiByApr.onLoad(this.revisaoEdicao)
            this.$refs.refTablaByApr.onLoad(this.revisaoEdicao)

            this.$refs.refFerramentasByApr.onLoad(this.revisaoEdicao)
            this.$refs.refRiscoEspecialByApr.onLoad(this.revisaoEdicao)
            this.$refs.refCursosNrByApr.onLoad(this.revisaoEdicao)
            this.$refs.refAprLog.onLoad()
            this.limparVariaveis()
          }).catch(Error => {
            loading.pop()
            toast.warning('Sem informações para alteração do Template')
          })
      } else {
        loading.pop()
        toast.info('Faça edições para continuar!')
      }
    },
    verificaSeTemAvaliacao (dados) {
      // Verifica se cada elemento possui a propriedade 'severidade'
      let todasSeveridadesPreenchidas = dados.every(item => item.hasOwnProperty('severidade'))

      if (todasSeveridadesPreenchidas === false) {
        let mensagem = 'A Riscos sem avaliação, por favor preencher as informações de SEVERIDADE e PROBABILIDADE!'
        return mensagem
      } else {
        return null
      }
    },
    riscoAddAvaliacao (value) {
      // Itera sobre cada riscoId em value
      for (let k = 0; k < value.length; k++) {
        const riscoId = value[k].riscoId
        // Itera sobre cada elemento em dataRiscoFonteConsequenciaMedida
        for (let i = 0; i < this.dataRiscoFonteConsequenciaMedida.length; i++) {
          if (this.dataRiscoFonteConsequenciaMedida[i].riscoId === riscoId) {
            if (this.dataRiscoFonteConsequenciaMedida[i].itens.naturezaRisco === value[k].causaId) {
              this.dataRiscoFonteConsequenciaMedida[i].causaId = value[k].causaId
              this.dataRiscoFonteConsequenciaMedida[i].APRId = value[k].aprTemplate
              this.dataRiscoFonteConsequenciaMedida[i].APRAgAprovacaoId = value[k].aprTemplateAgAprovacao === '' ? null : value[k].aprTemplateAgAprovacao
              this.dataRiscoFonteConsequenciaMedida[i].severidade = value[k].itens.severidade
              this.dataRiscoFonteConsequenciaMedida[i].probabilidade = value[k].itens.probabilidade
              this.dataRiscoFonteConsequenciaMedida[i].classificacao = value[k].itens.classificacao
            }
          }
        }
      }
    },
    edicaoRiscoAddAvaliacao (value) {
      // Itera sobre cada riscoId em value
      for (let k = 0; k < value.length; k++) {
        const riscoId = value[k].riscoId
        // Itera sobre cada elemento em dataRiscoFonteConsequenciaMedida
        for (let i = 0; i < this.edicaoDataRiscoFonteConsequenciaMedida.length; i++) {
          if (this.edicaoDataRiscoFonteConsequenciaMedida[i].riscoId === riscoId) {
            if (this.edicaoDataRiscoFonteConsequenciaMedida[i].itens.naturezaRisco === value[k].causaId) {
              this.edicaoDataRiscoFonteConsequenciaMedida[i].causaId = value[k].causaId
              this.edicaoDataRiscoFonteConsequenciaMedida[i].APRId = value[k].aprTemplate
              this.edicaoDataRiscoFonteConsequenciaMedida[i].APRAgAprovacaoId = value[k].aprTemplateAgAprovacao === '' ? null : value[k].aprTemplateAgAprovacao
              this.edicaoDataRiscoFonteConsequenciaMedida[i].severidade = value[k].itens.severidade
              this.edicaoDataRiscoFonteConsequenciaMedida[i].probabilidade = value[k].itens.probabilidade
              this.edicaoDataRiscoFonteConsequenciaMedida[i].classificacao = value[k].itens.classificacao
            }
          }
        }
      }
    },
    limparVariaveis () {
      this.dataRiscoFonteConsequenciaMedida = []
      this.edicaoDataRiscoFonteConsequenciaMedida = []
      this.dataEpi = []
      this.dataEpiExclusao = []
      this.dataCausaExclusao = []
      this.dataRiscoExclusao = []
      this.dataFerramentas = []
      this.dataFerramentasExclusao = []
      this.dataRiscoEspecial = []
      this.dataRiscoEspecialExclusao = []
      this.matrizRisco = []
      this.dataCursosNR = []
      this.dataCursosNRExclusao = []
    },
    irParaClonagem (obj) {
      this.templateClonado = obj
      this.$emit('templateClonado', this.templateClonado)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/components/tabsApr/tabsApr.js